module.exports = __webpack_public_path__ + "static/media/style.ae0a4e51.scss";


//////////////////
// WEBPACK FOOTER
// ./src/Sass/style.scss
// module id = 33
// module chunks = 0